export const LANG_PT_NAME = 'pt-BR';

export const LANG_PT_TRANS = {
    "SeparadorMilhar":".",
    "SeparadorDecimal":",",
    "FormatoDataCampo":"dd/mm/yy",
    "ErroAplicacao" :"Houve um erro na aplicação",
    "ErroAplicacao_Mensagem":"Houve um erro ao processar sua requisição. Por favor tente novamente e se o problema persistir, contate um administrador.",
    "ErroAplicacao_Descricao": "Descrição do erro",
    "Pesquisa": "Filtros",
    "Selecione": "Selecione",
    "Pesquisar": "Pesquisar",
    "Sim": "Sim",
    "Nao": "Não",
    "Acao": "Ação",
    "Novo": "Novo",
    "Salvar": "Salvar",
    "ValidarErro": "Alertas",
    "Cancelar": "Cancelar",
    "Confirmar":"Confirmar",
    "Manutencao": "Manutenção",
    "Voltar":"Voltar",
    "NomeSistema":"Won Internet Banking",
    "Operador":"Operador",
    "Codigo":"Código",
    "Nome":"Nome",
    "Login":"Login",
    "Email":"E-mail",
    "IdentificadorPerfil":"Perfil",
    "Ativo":"Ativo",
    "HorarioOperacao":"Horário Operação",
    "TipoTributo":"Tipo Tributo",
    "TipoOperacao":"Tipo Operação",
    "HorarioInicial":"Horário Inicial",
    "HorarioFinal":"Horário Final",
    "ApenasDiaUtil":"Dia Útil",
    "Paginacao_registrospagina":"Registros por página",
    "Paginacao_de":" de ",
    "Prosseguir":"Prosseguir",
    "NumeroConta":"Número da Conta",
    "Usuario":"Usuário",
    "Senha":"Senha",
    "Acessar":"Acessar",
    "SelecioneUsuario":"Selecione o seu usuário",
    "InternetBanking":"Internet Banking",
    "Administrativo":"Administrativo",
    "BemVindo":"Bem vindo",
    "AlterarSenha": "Alterar Senha",
    "SenhaAtual":"Senha Atual",
    "NovaSenha":"Nova Senha",
    "ConfirmarSenha":"Confirmar Senha",
    "ConfirmarExclusaoOperacaoHorario":"Tem certeza que deseja excluir o horário para {0}?",
    "ConfirmarExclusaoOperador":"Tem certeza que deseja excluir o operador {0}?",
    "Excluir":"Excluir registro",
    "PrecisaAjuda":"Precisa de Ajuda?",
    "TelefoneAjuda":"+55 11 3511-3389",
    "Transferencias":"Transferências",
    "Transferencia":"Transferência",
    "Pagamentos":"Pagamentos",
    "Extrato":"Extrato",
    "Pix":"Pix",
    "Investimentos":"Investimentos",
    "AprovacaoOperacao":"Aprovação Operação",
    "Tributos":"Tributos",
    "UploadArquivo":"Upload de Arquivo",
    "Administracao":"Administração",
    "TrocarSenha":"Trocar Senha",
    "GerarToken":"Gerar Token",
    "Liberar":"Liberar",
    "Monitor":"Monitor",
    "Atalhos":"Atalhos",
    "SaldoDisponivel":"Saldo Disponível",
    "SaldoTotal":"Saldo Total",
    "SaldoBloqueado":"Saldo Bloqueado",
    "PesquisarExtrato":"Descrição, Valor, ...",
    "De":"De",
    "Ate":"Até",
    "LancamentosFuturos":"Lançamentos Futuros",
    "LancamentosEfetivados":"Lancamentos Efetivados",
    "PosicaoInvestimento":"Posição de Investimento",
    "TotalLiquido":"Valor Total Líquido",
    "DataPosicao":"Data Posição",
    "AplicacaoDe":"Aplicação De",
    "AplicacaoAte":"Aplicação Até",
    "VencimentoDe":"Vencimento De",
    "VencimentoAte":"Vencimento Até",
    "PesquisarInvestimento":"Papel, Nota, Valor, ...",
    "Aplicacao":"Aplicação",
    "Vencimento":"Vencimento",
    "Papel":"Papel",
    "Nota":"Nota",
    "ValorAplicado":"Valor Aplicado",
    "SaldoBruto":"Saldo Bruto",
    "SaldoLiquido":"Saldo Líquido",
    "Impostos":"Impostos",
    "Operacoes":"Operações",
    "Arquivos":"Arquivos",
    "SituacaoArquivo":"Situação do Arquivo",
    "SituacaoOperacao":"Situação Operação",
    "ArrasteArquivo":"Arraste o arquivo para fazer o upload",
    "AddArquivoComputador":"Selecionar arquivo do computador",
    "PosicaoInvestimentoSemDados":"Não existe posição de investimento para a data informada",
    "InfomarToken":"Informe o Token de Confirmação do Aplicativo ou Dispositivo",
    "Contraparte":"Contraparte",
    'DataUploadDe':"Data Upload De",
    "DataUploadAte":"Data Upload Até",
    "DataUpload":"Data de Upload",
    "DataOperacaoDe":"Data Operação De",
    "DataOperacaoAte":"Data Operação Até",
    "TiposOperacao":"Tipos de Operação",
    "Situacao":"Situação",
    "NaoExistemOperacoes":"Não existem operações para exibir",
    "ValorTotal":"Valor Total",
    "ValorSucesso":"Valor Integrado Sucesso",
    "ValorCancelada":"Valor Cancelado",
    "ValorErro":"Valor Integrado Erro",
    "InfomarMotivo":"Informe o motivo",
    "DataOperacao":"Data da Operação",
    "Favorecido_CodigoBarras":"Favorecido/Código de Barras",
    "PosicaoArquivo":"Posição do Arquivo",
    "Motivo":"Motivo",
    "IncluirChave":"Incluir Chave",
    "Buscar":"Buscar",
    "MotivoObrigatorio":"Favor informar o motivo",
    "MotivoReprovacao":"Motivo Reprovação",
    "UsuarioReprovacao":"Usuário Reprovação",
    "NaoExistemArquivosFiltro":"Não existem arquivos para o filtro especificado",
    "NaoExistemPixFilto":"Não existem pix para o filtro especificado",
    "ExtratoConta":"Extrato da Conta",
    "ExtratoPix":"Extrato do Pix",
    "MinhasChaves":"Minhas Chaves",
    "TipoChave":"Tipo Chave",
    "EnviarToken":"Enviar Token Validação",
    "ReivindicarChave":"Reivindicação da Chave",
    "Chave":"Chave",
    "IdentificadorRequisicao":"Código Requisição",
    "DataRequisicao":"Data Requisição",
    "DadoRequisitante":"Dado Requisitante",
    "DadoRequisitado":"Dado Requisitado",
    "DataLimiteAcao":"Data Limite Ação",
    "Banco":"Banco",
    "CPF":"CPF",
    "CNPJ":"CNPJ",
    "MensagemToken":"Caso não receba o Token após 1 minuto gere novamente o Token",
    "TokenValidacao":"Token Validação",
    "ReceberPix":"Receber Pix",
    "Transferir":"Transferir",
    "PagarQRCode":"Pagar QR Code",
    "PixCopiaCola":"Pix Copia e Cola",
    "ConfirmarExclusaoChave":"Confirma a exclusão da chave {0}? Caso seja excluída não será mais possível receber pix por essa chave nessa conta.",
    "NaoExistemChaves":"Não existem chaves cadastradas para a conta",
    "ScanearQRCode":"Scaneie o QRCode abaixo no aplicativo do Woori Bank",
    "InformeTokenAtual":"Informe o Token exibido e clique em liberar para ativar o seu Token",
    "LerCamera":"Ler da Câmera",
    "LerArquivo":"Ler de Arquivo",
    "SeuSaldoDisponivel":"Seu saldo disponível",
    "Carregandosaldo":"Carregando Saldo ...",
    "DetalhesPagamento":"Detalhes Pagamento",
    "Recebedor":"Recebedor",
    "InformacoesAdicionais":"Informações Adicionais",
    "Identificador":"Identificador",
    "Descricao":"Descrição",
    "DescricaoOpcional":"Descrição(Opcional)",
    "DataPagamento":"Data do Pagamento",
    "Agendar":"Agendar",
    "Hoje":"Hoje",
    "DataExpiracao":"Data de Expiração",
    "DataVencimento":"Data de Vencimento",
    "DocumentoPagador":"Documento Pagador",
    "NomePagador":"Nome Pagador",
    "ValorOriginal":"Valor Original",
    "ValorFinal":"Valor Final",
    "ValorJuros":"Valor Juros",
    "ValorMulta":"Valor Multa",
    "ValorPago":"Valor Pago",
    "ValorDesconto":"Valor Desconto",
    "ValorAbatimento":"Valor Abatimento",
    "ValorDevolver":"Valor Devolver",
    "DigitarLinha":"Digitar Linha",
    "IncluirDevolucaoEspecial":"Incluir Devolução Especial",
    "DetalheDevolucaoEspecial":"Detalhe Devolução Especial",
    "IdentificadorDevolucao":"Identificador da Devolução Especial",
    "SPBParticipanteSolicitante":"SPB Participanete Solicitante",
    "SPBParticipanteContestado" :"SPB Participante Contestado",
    "CodigoTransacaoDevolucao":"Código da Transação de Devolução",
    "SituacaoAnalise":"Situação Análise",
    "MotivoRejeicao":"Motivo da Rejeição",
    "TipoParticipacao":"Tipo da Participação",
    "ValorDevolvido":"Valor Devolvido",
    "FecharDevolucaoEspecial":"Fechar Devolução Especial",
    "ConfirmaCancelarDevolucaoEspecial":"Confirma o cancelamento desta devolução especial?",
    "Pagar":"Pagar",
    "VoltarPix":"Voltar para Pix",
    "Solicitante":"Solicitante",
    "Contestado":"Contestado",
    "VerComprovante":"Ver Comprovante",
    "SelecionarPixDevolucaoEspecial":"Selecionar Pix para Devolução Especial",
    "MensagemPixSucesso":"O pix para <strong>{0}</strong> no valor de <strong>R$ {1}</strong> {2}",
    "MensagemTransferenciaSucesso":"A transferência para <strong>{0}</strong> no valor de <strong>R$ {1}</strong> {2}",
    "MensagemPagamentoSucesso":"O Pagamento da boleta <strong>{0}</strong> no valor de <strong>R$ {1}</strong> {2}",
    "MensagemTributoSucesso":"O Pagamento do tributo no valor de <strong>R$ {0}</strong> {1}",
    "PixAgendado":"foi agendado",
    "ConfirmacaoPagamento":"Confirmação de Pagamento",
    "PixEnviadoAprovacao":"foi enviado para aprovação",
    "PixExecutando":"está sendo executado",
    "PixConcluido":"foi concluído com sucesso",
    "ConfirmacaoTributo":"Confirmação de Tributo",
    "PixRealizado":"Pix realizado em ",
    "IdentificadorTransacao":"ID Transação",
    "ValorAtualizado":"Valor Atualizado",
    "ErrosOperacao":"Erros da Operação",
    "TransacaoOriginal":"ID Transação Original",
    "ValorPrincipal":"Valor Principal",
    "ValorOutraEntidade":"Valor Outra Entidade",
    "ValorEncargo":"Valor de Encargos",
    "ValorAcrescimoFinanceiro":"Valor Acréscimo Financeiro",
    "ValorHonorarioAdvocaticio":"Valor Honorário Advocatício",
    "ProtocoloTributo":"Protocolo de Tributos",
    "PagamentoTributo": "Pagamento de ",
    "NumeroDARF":"Número DARF",
    "DadosTributo":"Dados do Tributo",
    "Endereco":"Endereço",
    "CEP":"CEP",
    "Bairro":"Bairro",
    "Municipio":"Município",
    "Estado":"UF",
    "ValorReceitaBruta":"Valor Receita Bruta",
    "PercentualReceitaBruta":"Percentual Receita Bruta",
    "NumeroIncricao":"Número da Inscrição",
    "IdentificacaoContribuinte":"Identificador Contribuinte",
    "TipoIdentificacaoContribuinte":"Tipo Identificador",
    "IdentificadorFGTS":"Identificador FGTS",
    "CodigoBarras":"Código de Barras",
    "InscricaoEstadual":"Inscrição Estadual",
    "DividaAtiva":"Dívida Ativa",
    "TokenLiberado":"O token MFA foi liberado para o usuário. Ele deve acessar a tela para scanear o Qr Code para passar a utilizado",
    "CNAE":"CNAE",
    "AIIM":"AIIM",
    "Parcelamento":"Parcelamento",
    "CodigoGare":"Código Receita",
    "TipoInscricao":"Tipo Inscrição",
    "CodigoReceitaTesouro":"Código Receita Tesouro",
    "AutorizaPagamento":"Autorizar Pagamento",
    "CodigoGPS":"Código GPS",
    "AnoMesCompetencia":"Mês/Ano Competência",
    "DataReferencia":"Data de Referência",
    "Origem":"Origem",
    "Destino":"Destino",
    "DadosDevolucao":"Dados da Devolução",
    "DadosOperacao":"Dados da Operação",
    "pelo":" pelo ",
    "ProtocoloPix":"Protocolo",
    "PixDevolucao":"Devolução Pix",
    "Devolucoes":"Devoluções",
    "DadosBancarios":"Dados Bancários",
    "DadosChave":"Dados da Chave",
    "AgenciaConta":"Agência e Conta",
    "TipoConta":"Tipo Conta",
    "NaoPossuiAgencia":"Não Possui Agência",
    "Agencia":"Agência",
    "Conta":"Conta",
    "Digito":"Dígito",
    "ContaDigito":"Conta - Dígito",
    "AgenciaContaDigito":"Agência / Conta - Dígito",
    "MesmaTitularidade":"Mesma Titularidade",
    "OutraTitularidade":"Outra Titularidade",
    "Documento":"Documento",
    "Estatico":"Estático",
    "Dinamico":"Dinâmico",
    "PossuiVencimento":"Possui Vencimento",
    "Devedor":"Devedor",
    "NomeDevedor":"Nome",
    "DocumentoDevedor":"Documento",
    "NumeroDiasReceberAposVencimento":"Número de Dias Receber após vencimento",
    "SegundosParaExpiracao":"Segundos para Expiração",
    "PossuiMora":"Possui Mora",
    "TaxaMora":"Valor Diário de Mora",
    "DataInicioMora":"Data Início de Mora",
    "PossuiDesconto":"Possui Desconta",
    "DataLimiteDesconto":"Data Limite Desconto",
    "TaxaDesconto":"Valor Desconto",
    "PossuiMulta":"Possui Multa",
    "TaxaMulta":"Valor Multa",
    "ProtocoloTransferencia":"Protocolo Transferência",
    "executada":"executada",
    "emprocessamento":"em processamento",
    "CodigoOperacao":"Código Operação",
    "TransferenciaDataEfetivacao":"Transferência efetivada em",
    "DadosContaDebitada":"Dados conta debitada",
    "DadosContaCreditada":"Dados conta creditada",
    "OutrasInformacoes":"Outras Informações",
    "DataInicioMulta":"Data Início Multa",
    "SolicitacaoPagador":"Solicitação ao Pagador",
    "CadastrarFavorecido":"Cadastrar Favorecido",
    "Finalidade":"Finalidade",
    "ConfirmarExclusaoContato":"Confirma a exclusão do favorecido {0} no banco {1}?",
    "NovaConta":"NovaConta",
    "ProtocoloPagamento":"Protocolo Pagamento",
    "ValorBoleto":"Valor Boleto",
    "Segmento":"Segmento",
    "CodigoInstituicao":"Código Instituição",
    "DadosBoleto":"Dados Boleto",
    "LinhaDigitada":"Linha Digitada",
    "BancoLiquidacao":"Banco Liquidação",
    "Pagamento":"Pagamento",
    "PesquiseContato":"Pesquise um Contato",
    "Favorecidos":"Favorecidos",
    "FavorecidosCadastrados":"Favorecidos Cadastrados",
    "TipoTransferencia":"Tipo de transferência",
    "NovoFavorecido":"Novo Favorecido",
    "IdentificadorOrigem":"Identificador Origem",
    "ConfirmacaoTransferencia":"Confirmação da Transferência",
    "AlertaCompartilharPix":"Ao compartilhar o QRCode os usuários terão acessos a seu nome, instituição financeira e documento mascarado. Deseja prosseguir com a geração?",
    "ConfirmacaoDados":"Confirmação Dados",
    "ColarCodigoPagamento":"Colar abaixo o código do pagamento recebido",
    "CodigoPagamentoCopiado":"Código de Pagamento copiado para área de transferência",
    "CompartilharQrCode":"Compartilhar QR Code",
    "SalvarImagem":"Salvar Imagem",
    "DadosOperacaoDevolvida":"Dados Operação Devolvida",
    "MonitorOperacao":"Monitor de Integração",
    "MonitorOperacaoStatus":"Status",
    "MonitorOperacaoDtEnvio":"Data de envio",
    "MonitorOperacaoDocumento":"CPF/CNPJ",
    "MonitorOperacaoCliente":"Cliente",
    "MonitorOperacaoDtDe":"De",
    "MonitorOperacaoDtAte":"Até",
    "MonitorOperacaoOperacao":"Dados de Operação",
    "MonitorOperacaoValor":"Valor",
    "MonitorOperacaoHistorico":"Histórico",
    "MonitorOperacaoConta":"N° Conta",
    "MonitorOperacaoAgencia":"N° Agência",
    "MonitorOperacaoBanco":"N° Banco",
    "MonitorOperacaoFavorecido":"Favorecido",
    "MonitorOperacaoTipo":"Tipo",
    "MonitorOperacaologIdentificador":"ID",
    "MonitorOperacaologDataLog":"Data de Log",
    "MonitorOperacaologAcao":"Ação Realizada",
    "CNPJWooribank":'15.357.060/0001-33',
    "EnderecoWooribank":"Av. das Nações Unidas, 14171 - Cj 803 - Torre C Crystal Tower - Vila Gertrudes, São Paulo",
    "TelefoneWooribank":"(11)3511-3389",
    "TelefoneLink":'tel:1135113389',
    "TodosDireitosReservados":"Todos os direitos reservados",
    "Wooribank":"Woori Bank",
    "InformeLog":"Informações do Log",
    "TokenEMail":"Token Recebido no E-Mail",
    "TokenCelular":"Token Recebido no Celular",
    "Cliente":"Cliente",
    "ClienteNome":"Nome",
    "ClienteDocumento":"Documento",
    "ClienteAgencia":"Agência",
    "ClienteConta":"Conta",
    "ClienteDataInclusao":"Data Inclusão",
    "ClienteValorLimite":"Valor Limite",
    "ClienteCodigoConta":"Código Conta",
    "ClienteToken":"Token",
    "ClienteDuplaAlcada":"Dupla Alcada",
    "ClienteAtivo":"Ativo",
    "ClienteQuantidadeAprovacao":"Qtd. Aprovação",
    "TipoAlerta":"Tipo de Alerta",
    "InformeRendimento":"Informe de Rendimento",
    "TituloInformeRendimento":"Gerar Informe Rendimento {0}",
    "TituloConfirmaBaixa":"Confirma a baixa do título para {0} no valor de {1}?",
    "UsuarioNome":"Nome",
    "UsuarioPerfil":"Perfil",
    "UsuarioDocumento":"Documento",
    "UsuarioEmail":"E-mail",
    "UsuarioAtivo":"Ativo",
    "UsuarioDataInclusao":"Data Inclusão",
    "UsuarioToken":"Token",
    "UsuarioBtnToken":"Liberar Token",
    "DesbloquearToken":"Desbloquear Token",
    "UsuarioTpDocumento":"Tipo Documento",
    "UsuarioSenha":"Senha",
    "Usuarios":"Usuários",
    "Permissoes":"Permissões",
    "UsuarioResetSenha":"Reset Senha",
    "UsuarioTokenMobile":"Token Mobile",
    "PortabilidadeDoador":"Você iniciou a portabilidade desta chave ",
    "PosseDoador":"Você foi solicitado a passar a posse desta chave",
    "PortabilidadeRequisitante":"Você solicitou a portabilidade desta chave",
    "PosseRequisitante":"Você requisitou a posse desta chave",
    "Alertas":"Alertas",
    "ConfiguracaoUsuario":"Minhas Configurações",
    "UsuarioPesquisa": "Filtros Usuário",
    "ConfirmarExclusaoMensagem":"Deseja excluir a mensagem {0}?",
    "PerfilContaNome":"Nome",
    "PerfilPesquisa":"Filtros",
    "PerfilNome":"Nome",
    "PerfilContaAdm":"Administrador",
    "PerfilContaLimiteOperador":"Possui Limite para Lançar Operação",
    "PerfilContaLimiteVLOperador":"Valor Limite Operação",
    "PerfilContaLimiteAprovacao":"Possui Limite para Aprovar Operação",
    "PerfilContaLimiteVLAprovacao":"Valor Limite Aprovação",
    "PerfilContaPesquisa": "Filtros Perfil",
    "ConfirmarExclusaoPerfilConta":"Tem certeza que deseja excluir o perfil {0}?",
    "PerfilContaFuncionalidade":"Funcionalidades",
    "UsuarioCelular":"Celular",
    "LimiteTipoCliente":"Limite Tipo Cliente",
    "LimiteTipoClienteDescricao":"Descrição",
    "LimiteTipoClienteValor":"Valor",
    "LimiteTipo":"Tipo Pessoa",
    "Rotina":"Rotina",
    "Detalhes":"Detalhes",
    "Chaves":"Chaves",
    "Campo":"Campo",
    "Data":"Data",
    "DataDe":"Data de",
    "DataAte":"Data até",
    "Funcionalidade":"Funcionalidade",
    "ValorAnterior":"Valor Anterior",
    "Valor":"Valor",
    "LogAcao":"Log de Ações",
    "IdiomaMensagens":"Idioma das Mensagens",
    "RegistrosFilhos":"Registros Filhos",
    "CamposModificados":"Campos Modificados",
    "NaoExistemAlertas":"Não existem alertas!",
    "MonitorArquivoCliente":"Cliente",
    "MonitorArquivoStatus":"Status",
    "MonitorArquivoDtDe":"De",
    "MonitorArquivoDtAte":"Até",
    "InformarValor":"Informar o valor",
    "MonitorArquivoDocumento":"CPF/CNPJ",
    "MonitorArquivoDtEnvio":"Data de envio",
    "MonitorArquivoDtAprovacao":"Data de Aprovação",
    "MonitorArquivo":"Monitor Arquivo",
    "OrigemAcao":"Origem da Ação",
    "Parametrizacao":"Parametrização",
    "ParametrizacaoCodigoSistema":"Código do Sistema",
    "ParametrizacaoCodigoProduto":"Código do Produto",
    "ParametrizacaoCodigoEmpresa":"Código da Empresa",
    "ParametrizacaoIndicadorProvisao":"Indicador da Provisão",
    "ParametrizacaoIndicadorLiberado":"Indicador Liberado",
    "ParametrizacaoIndicadorLiquidado":"Indicador Liquidado",
    "ParametrizacaoCodigoMoeda":"Código da Moeda",
    "ParametrizacaoCodigoLancamentoTransferencia":"Código de Lançamento Transferência",
    "ParametrizacaoCodigoProdutoTransferencia":"Código de Produto Transferência",
    "ParametrizacaoCodigoLancamentoTED":"Código de Lançamento TED",
    "ParametrizacaoCodigoProdutoTED":"Código de Produto TED",
    "ParametrizacaoCodigoLancamentoDOC":"Código de Lançamento DOC",
    "ParametrizacaoCodigoProdutoDOC":"Código de Produto DOC",
    "ParametrizacaoCodigoLancamentoBoleto":"Código de Lançamento Boleto",
    "ParametrizacaoCodigoProdutoBoleto":"Código de Produto Boleto",
    "ParametrizacaoCodigoLancamentoConcessionaria":"Código de Lançamento Concessionária",
    "ParametrizacaoCodigoProdutoConcessionaria":"Código de Produto Concessionária",
    "ParametrizacaoCodigoLancamentoDARF":"Código de Lançamento DARF",
    "ParametrizacaoCodigoProdutoDARF":"Código de Produto DARF",
    "ParametrizacaoCodigoLancamentoGPS":"Código de Lançamento GPS",
    "ParametrizacaoCodigoProdutoGPS":"Código de Produto GPS",
    "ParametrizacaoCodigoLancamentoGARE":"Código de Lançamento GARE",
    "ParametrizacaoCodigoProdutoGARE":"Código de Produto GARE",
    "ParametrizacaoCodigoLancamentoGAREICMS":"Código de Lançamento GARE ICMS",
    "ParametrizacaoCodigoProdutoGAREICMS":"Código de Produto GARE ICMS",
    "ParametrizacaoCodigoLancamentoFGTS":"Código de Lançamento FGTS",
    "ParametrizacaoCodigoProdutoFGTS":"Código de Produto FGTS",
    "ParametrizacaoCodigoLancamentoIPTU":"Código de Lançamento IPTU",
    "ParametrizacaoCodigoProdutoIPTU":"Código de Produto IPTU",
    "ParametrizacaoCodigoLancamentoGNRE":"Código de Lançamento GNRE",
    "ParametrizacaoCodigoProdutoGNRE":"Código de Produto GNRE",
    "ParametrizacaoCodigoFinalidade":"Código Finalidade Boleto",
    "ParametrizacaoTempoEsperaMultiliquidacao":"Segundos Espera Multiliquidação",
    "ParametrizacaoConfigEmail":"Configurações de Email",
    "ParametrizacaoConfigGerais":"Configurações Gerais",
    "ParametrizacaoConfigToken":"Configurações do Token",
    "ParametrizacaoConfigPlanilha":"Confgurações Planilha",
    "ParametrizacaoServidorSMTP":"Servidor SMTP",
    "ParametrizacaoPorta":"Porta",
    "ParametrizacaoCkeckCred":"Utilizar Credenciais",
    "ParametrizacaoCkeckCredDefault":"Utilizar Credenciais Default",
    "ParametrizacaoCkeckSSL":"Utilizar SSL",
    "ParametrizacaoUsuario":"Usuário",
    "ParametrizacaoSenha":"Senha",
    "ParametrizacaoEmailRemetente":"Email do Remetente",
    "ParametrizacaoTentativasBloquearUsuario":"Tentativas Senha Bloquear Usuário",
    "ParametrizacaoPrefixoAssunto":"Prefixo do Assunto",
    "ParametrizacaoAprovacaoInterna":"Utilizar Aprovação Interna",
    "ParametrizacaoOperadorOperacoes": "Selecione o Operador pelas operações",
    "ParametrizacaoHorarioUpdate": "Horário Limite para Upload de Arquivo",
    "ParametrizacaoTamanhoLimiteUpdate":"Tamanho Limite para o Upload do Arquivo",
    "ParametrizacaoDominio":"Domínio",
    "ParametrizacaoValorDoc":"Valor máximo para DOC",
    "ParametrizacaoValorTED":"Valor Minimo para TED",
    "ParametrizacaoValorTarifaDOC":"Tarifa DOC",
    "ParametrizacaoValorTarifaTED":"Tarifa TED",
    "ParametrizacaoJanelaTempo":"Janela de Tempo - OTP(seg)",
    "ParametrizacaoJanelaTempoAssinatura":"Janela de Tempo - Assinatura(seg)",
    "ParametrizacaoDesblqAutomaticoDiario":"Desbloqueio automático diário",
    "ParametrizacaoExpiracaoToken":"Expiração do token habilitada",
    "ParametrizacaoNumeroMaximoErro": "Número Máximo de Erros",
    "ParametrizacaoDesbloqApos":"Desbloqueio automático após",
    "ParametrizacaoDiferencaHoraGMT":"Diferença de Horas para GMT",
    "ParametrizacaoAtivarToken":"Ativar Todos Tokens",
    "ParametrizacaoLocalUpload":"Local de Upload",
    "ParametrizacaoPlanilhaTransacoes":"Planilha Transações",
    "ParametrizacaoPlanilhaTributos":"Planilha Tributos",
    "ParametrizacaoDownload":"Download",
    "ParametrizacaoDownloadTributos":"Download Tributos",
    "ErroAcessoExpirado": "O tempo de acesso expirou, é necessário refazer o login",
    "DataCriacao": "Data de criação",
    "ProtocoloGerarPdf":"Gerar PDF",
    "ClienteManutencao": "Cliente:",
    "ConfirmarExclusaoLimite":"Confirma a exclusão do limite para o tipo de cliente {0}?",
    "LimitePixDiaUtil":"Limite Pix dias úteis das 6h as 20h",
    "LimitePixDiaNaoUtil":"Limite Pix Sábados, Domingos e Feriados ou das 20h as 6h",
    "LimitePixDiaUtilAprovacao":"Aprovação para Limite Pix dias úteis das 6h as 20h ",
    "LimitePixDiaNaoUtilAprovacao":"Aprovação para Limite Pix Sábados, Domingos e Feriados ou das 20h as 6h ",
    "LimitePixDiaUtilEspecie":"Limite Valor em Espécie Recebido para Pix em dias úteis das 6h as 20h ",
    "LimitePixDiaNaoUtilEspecie":"Limite Valor em Espécie Recebido para Pix aos Sábados, Domingos e Feriados ou das 20h as 6h ",
    "AgenteSaque":"Agente de Saque",
    "ValorTaxaSaque":"Taxa Saque por Transação",
    "BeneficiarioDiferenteCedente":"Beneficiário não é o Cedente",
    "EnviarPorMail":"Enviar boleto para e-mail do sacado",
    "DataMulta":"Data da Multa",
    "CPFCNPJ":"CPF/CNPJ",
    "EMail":"E-mail",
    "TipoPessoa":"Tipo Pessoa",
    "TipoMulta":"Tipo de Multa",
    "TipoDesconto":"Tipo de Desconto",
    "TipoJuros":"Tipo de Juros",
    //Novos Textos Passar para tradução
    "ControleTitulos":"Controle de Títulos",
    "EnviarTituloMail":"Enviar Boleto por e-Mail",
    "DataEmissaoDe":"Emissão De",
    "DataEmissaoAte":"Emissão Até",
    "DataEmissao":"Data de Emissão",
    "DataLiquidacao":"Data de Liquidação",
    "DataBaixa":"Data de Baixa",
    "Sacado":"Sacado",
    "MensagemMail":"Texto enviado no e-mail",
    "NossoNumero":"Nosso Número",    
    "ValorLiquido":"Valor Líquido",
    "SeuNumero":"Seu Número",
    "CPFCNPJSacado":"CPF/CNPJ Sacado",
    "SemBoletoEmitidos":"Não existem boletos emitidos para a busca realizada",
    "BoletosEmitidos":"Boletos Emitidos",
    "ParametrizacaoIndicadorPrevisao":"Indicador de Previsão",
    "ErroInformado":"Descrição do Erro Ocorrido",
    "TrocarSituacaoErro":"Trocar Situação da Operação para com Falhas",
    "TextoTitulo":"O Internet Banking desenvolvido para os clientes do <b>Woori Bank do Brasil</b> com objetivo de oferecer <b>qualidade e segurança</b> nos nossos serviços",
    "TextoSubtitulo":"Experimente também nosso App",
    "TextoBeneficios":"Conheça todos os<br><strong>benefícios do Woori Bank</strong>",
    "TextoPagamentos":"Pix, Transferências e Pagamentos",
    "TextoLancamentos":"Investimentos, Lançamentos Futuros e muitos outros",
    "LancamentosEfetuados":"Lançamentos Efetuados",
    "ArquivoInformacoesLegais":"Informações Legais",
    "InformacoesLegais":"Informações Legais",
    "LimitePix":"Limite Pix",
    "ArquivoToken":"Arquivo de Tokens",
    "DataBlink":"DataBlink",
    "ChaveArquivo":"Chave do Arquivo",
    "NumeroMaximoErros":"Número máximo de Erros",
    "JanelaOTP":"Janela OTP (0-86400)",
    "JanelaAssinatura":"Janela de Assinatura (0-86400)",
    "JanelaAutenticacaoAvancada":"Janela de Autenticação Avançada (0-86400)",
    "TokenExpira":"Token Expira",
    "HorasDesbloqueioAutomatico":"Horas Desbloqueio Automático(0-168)",
    "MinutosDesbloqueioAutomatico":"Minutos Desbloqueio Automático(0-10080)",
    "DesbloqueioAutomaticoDiario":"Desbloqueio automático diário",
    "TokenScaneadoSucesso":"Token configurado com sucesso",
    "ModeloArquivoTributo":"Baixar Modelo Arquivo Tributo",
    "ModeloArquivoOperacao":"Baixar Modelo Arquivo Operação",
    "TokenEnviadoEmail":"Quando salvar será enviado um token para este e-mail para garantir que você tem acesso a ele",
    "TokenEnviadoCelular":"Quando salvar será enviado um token via SMS para o celular para garantir que você tem acesso a ele",
    "ConfirmarCancelamentoArquivo":"Confirma o cancelamento da execução do arquivo?",
    "ContaCadastrada":"Conta Cadastrada",
    "ValorEspecie":"Valor em Espécie",
    "Relatorios":"Relatórios",
    "DataInicio":"Data Início",
    "DataFim":"Data Fim",
    "Excel":"Excel",
    "PDF":"PDF",
    "DatasAnteriores":"Datas Anteriores",
    "ClientesCadastrados":"Clientes Cadastrados",
    "PrimeirosLogins":"Primeiros Logins Clientes Antigos",
    "PrimeirosLoginsNovo":"Primeiros Logins Clientes Novos",
    "PrimeirosLoginsInternetBank":"Primeiros Logins(Internet Banking)",
    "PrimeirosLoginsMobileBank":"Primeiros Logins (Mobile Banking)",
    "ChavesCadastradas":"Chaves Cadastradas",
    "ClientesRegistraramChave":"Clientes Antigos que Registraram Chaves",
    "ClientesNovosRegistraramChave":"Clientes Novos que Registraram Chaves",
    "OperacoesRealizadas":"Operações Realizadas",
    "ClientesRealizaramOperacoes":"Clientes que Realizaram Operações",
    "ResumoCliente":"Resumo Diário Clientes",
    "ResumoPix":"Resumo Diário Pix",
    "Relatorio":"Relatório",
    "PleaseEnterToken":"Por favor, insira o token enviado:",
    "PleaseSelectTokenSendOption": "Por favor, selecione o modo de envio do token de confirmação:",
    "TokenInvalido": "Token Inválido",
    "SenhaAlterada": "Senha alterada com sucesso",
    "SelecionarMetodoEnvio": "Por favor, selecione o método de envio",
    "TokenInserir":"Token Recebido",
    "DetalheCliente":"Clientes Cadastrados",
    "DetalheDict":"Chaves Cadastradas",
    "DataCadastro":"Data de Cadastro",
    "NaoExistemRegistros":"Não existem resultados para a consulta realizada",
    "TextoAceitacao":"Texto Aceitação Internet Banking",
    "TermoUtilizacaoInternetBanking":"Termo Utilização Internet Banking",
    "LieAceitoTermos":"Li e aceito os termos",
    "PrestadorServico":"Prestador de Serviço Espécie",
    "ModalidadeAgente":"Modalidade do Agente",  
    "Token_Mobile":"Mobile",
    "Token_Fisico":"Físico",
    "ValorMaximo":"Valor Máximo",
    "DadosRecebimento":"Dados do Recebimento",
    "CEPPagador":"CEP",
    "EMailPagador":"E-Mail",
    "TelefonePagador":"Telefone",
    "EnderecoPagador":"Endereço",
    "PermiteAlteracaoValor":"Permite Alterar Valor",
    "MunicipioPagador":"Cidade",
    "UFPagador":"UF",
    "Modalidade":"Modalidade",
    "PossuiJuros":"Possui Juros",
    "PossuiAbatimento":"Possui Abatimento",
    "TaxaJuros":"Taxa Juros",
    "TaxaAbatimento":"Taxa Abatimento",
    "DatasDesconto":"Datas de Desconto",
    "RelatorioAPIX001":"Arquivo APIX001",
    "RelatorioTelefoneResponsavel":"Telefone Responsável",
    "RelatorioEmailResponsavel":"E-Mail Responsável",
    "RelatorioNomeResponsavel":"Nome Responsável",
    "RelatorioIndiceDisponibilidade":"Índice de Disponibilidade",
    "RelatorioDtArquivo":"Data do Arquivo",
    "RelatorioAno":"Ano de Referência",
    "RelatorioMes":"Mês de Referência",
    "RelatorioISPB":"ISPB do Participante",
    "RelatorioTransacoes":"Informação sobre Transações",
    "RelatorioQtdTransacoes":"Quantidade de transações",
    "RelatorioValorTransacoes":"Montante financeiro das transações",
    "RelatorioDetalhamentoTransacoes":"Detalhamento das transações",
    "RelatorioQtdeBloqCaut":"Quantidade de transações bloqueadas cautelarmente",
    "RelatorioValorBloqCaut":"Montante financeiro das transações bloqueadas cautelarmente",
    "RelatorioDetalhamentoTransacoesBloqCaut":"Detalhamento das transações bloqueadas cautelarmente",
    "RelatorioTempoMaxBloqueioCautelar":"Tempo máximo entre a ativação do bloqueio cautelar e a conclusão do processo (transações liquidadas no SPI + fora do SPI)",
    "RelatorioValorEspecie":"Montante financeiroem espécie",
    "RelatorioFinalidadeTransacoes":"Finalidade das transações",
    "RelatorioDevolucoes":"Informações sobre devoluções",
    "RelatorioQtdDevolucoes":"Quantidade de devoluções",
    "RelatorioBloqueiosCautelar":"Informações de transações bloqueadas cautelarmente (SPI + fora SPI)",
    "RelatorioValorDevolucoes":"Montante financeiro das devoluções",
    "RelatorioReceitas":"Informações sobre a receita auferida com tarifas sobre transações",
    "RelatorioValorReceita":"Montante financeiro da receita total com tarifas sobre transações Pix",
    "RelatorioFonteReceita":"Fonte da receita",
    "RelatorioTemposTransacoes":"Informações sobre os indicadores de tempos das transações informados pelos participantes do Pix, como definidos na seção 3.1.2 do Manual de Tempos do Pix (versão 2.0)",
    "RelatorioPerc50TempoExpUsuarioLiqSPI":"Percentil 50 do tempo relacionado à experiência do usuário pagador (transações liquidadas no SPI)",
    "RelatorioPerc99TempoExpUsuarioLiqSPI":"Percentil 99 do tempo relacionado à experiência do usuário pagador (transações liquidadas no SPI)",
    "RelatorioPerc50TempoExpUsuarioLiqForaSPI":"Percentil 50 do tempo relacionado à experiência do usuário pagador (transações fora do SPI)",
    "RelatorioPerc99TempoExpUsuarioLiqForaSPI ":"Percentil 99 do tempo relacionado à experiência do usuário pagador (transações fora do SPI). ",
    "RelatorioTemposDict":"Informações sobre os indicadores de tempos do DICT informados pelos participantes do Pix, como definidos na seção 3.2.2 do Manual de Tempos do Pix (versão 2.0)",
    "RelatorioPerc99TempoUsuarioConsulta":"Percentil 99 do tempo do usuário pagador na consulta ao DICT",
    "RelatorioPerc99TempoEnvioRegistro":"Percentil 95 do tempo para envio do código para e-mail ou número de telefone celular no registro de chave",
    "RelatorioPerc99TempoExpUsuarioRegistro":"Percentil 95 do tempo relacionado à experiência do usuário pagador no registro de chave",
    "RelatorioPerc99TempoNotificacaoPortabilidade":"Percentil 95 do tempo decorrido entre o recebimento (acknowledge) no DICT e a notificação ao usuário doador em ambiente logado (processo de portabilidade ou de reivindicação de posse)",
    "RelatorioPerc99TempoEnvioPortabilidade":"Percentil 95 do tempo decorrido entre a ação do usuário (confirmação ou cancelamento) e o envio da informação para o DICT (processo de portabilidade ou de reivindicação de posse)",
    "RelatorioPerc99TempoExpUsuarioExclusao":"Percentil 95 do tempo relacionado à experiência do usuário pagador na exclusão de chave",
    "RelatorioConsultaDict":"Informações sobre consultas ao DICT",
    "RelatorioQtdConsultas":"Quantidade de consultas à base interna do participante",
    "RelatorioDisponibilidade":"Informações sobre a disponibilidade do participante do Pix",
    "RelatorioTipoEnvio":"Tipo de Envio",
    "DataAssociacao":"Data Associação",
    "SegregarLimiteTipoOperacao":"Segregar Limite por Tipo de Operação",
    "TipoEnvio":"Tipo de Envio",
    "TipoEnvio_NovasInformacoes":"Novas informações",
    "TipoEnvio_Alteracao":"Alteração de informações enviadas previamente",
    "Reclamacao":"Reclame Aqui",
    "ReclamacaoTextoDialogo":"Antes de fazer uma reclamação no Banco Central do Brasil, tente resolver o problema junto à nossa Central de Atendimento.",
    "BtnFechar":"Fechar",
    "ReclamacaoCanalAtdTexto":"Canal de Atendimento",
    "ReclamacaoBancoCentralTexto":"Canal de Atendimento do Banco Central do Brasil",
    "ReclamacaoLinkPix":"https://www.bcb.gov.br/acessoinformacao/registrar_reclamacao",
    "ReclamacaoModalTitulo": "Formulário de Reclamação",
    "Titulo": "Titulo da reclamação",
    "PixAgendadoPara":"Pix agendado para",
    "as":"as",
    "agendadopara":" agendado para ",
    "agendadapara":" agendada para ",
    "Favoritos":"Favoritos",
    "RodapeManualPt": "Manual do Usuário Português",
    "RodapeManualKr": "Manual do Usuário Coreano",
    "RodapeVideo": "Video Explicativo",
    "TipoToken":"Tipo de Token",
    "CodigoToken":"Código do Token",
    "RelatorioToken":"Tokens",
    "AprovacaoManualNecessaria":"Aprovação Manual da alteração pelo Gerente Woori Bank necessária",
    "EmUso":"Em Uso",
    "Todos":"Todos",
    "ControleReclamacoes":"Controle de Reclamações",
    "DataReclamacao":"Data da Reclamação",
    "DataReclamacaoDe":"Data da Reclamação De",
    "DataReclamacaoAte":"Data da Reclamação Até",
    "Aberta":"Aberta",
    "DataResposta":"Data da Resposta",
    "Resposta":"Resposta",
    "UsuarioResposta":"Operador Resposta",
    "CancelarAgendamento":"Cancelar Agendamento",
    "TextoReclamacao":"Reclamação",
    "ConfirmarExclusaoMensagemSelecionadas":"Confirma a exclusão das mensagens selecionadas",
    "SelecionarTodos":"Selecionar Todos",
    "AprovarLimitePix":"Aprovar Limite Pix",
    "TipoHorarioPix":"Horário Pix",
    "TipoLimitePix":"Tipo Operação Limite",
    "DataAprovacao":"Data Aprovação",
    "OpenBanking": "Open Banking",
    "TextoOpenBanking1":"Open Banking é um serviço financeiro que especifica um conjunto de regras sobre o uso e compartilhamento de dados e informações financeiras entre as instituições, proporcionando melhores produtos e serviços financeiro para você.",
    "TextoOpenBanking2":"Se quiser saber mais como o Open Banking funciona e como ele é capaz de mudar para melhor a vide de muitos brasileiros, acesse:",
    "MeusPagamentos":"Meus Pagamentos",
    "ReverOnboarding":"Rever Onboarding",
    "PortaldoCidadao":"Portal do Cidadão",
    "UsarPix":"Usar Pix",
    "ContaOrigem":"Conta Origem",
    "ContaDestino":"Conta Destino",
    "AgenciaOrigem":"Agência Origem",
    "AgenciaDestino":"Agência Destino",
    "NomeDestinatario":"Nome Beneficiado",
    "DocumentoDestinatario":"Documento Beneficiado",
    "DevolucaoEspecialPix":"Devolução Especial Pix",
    "RequisitarDevolucao":"Requisitar Devolução",
    "InfracoesPix":"Infrações Pix",
    "MeusPagamentosSemDados":"Não existem pagamentos para exibir",
    "DetalheFacilSemCustos":"Suas transações podem ser feitas via Chave ou QR Code, de forma simples, prática e sem cobrar nenhuma taxa a mais por isso.",
    "DetalheTransacoesRapidas":"Realize pagamentos e transferências em poucos segundos, em qualquer dia e horário.",
    "FacilSemCustos":"Fácil e sem custos",
    "TransacoesRapidas":"Transações Rápidas",
    "ConsentimentoNovaTransacao":"Consentimento de Transação",
    "TextoRedirecionamentoInstituicao":"Para que possamos concluir o pagamento, iremos lhe redirecionar para a instituição:",
    "AlertaCancelamentoAgendamentoPagamento":"O processo de cancelamento do agendamento é uma ação irreversível.<br/>O Agendamento não será efetivado, caso mude de idéia terá que realizar um novo agendamento.<br/><br/>Tem certeza que deseja cancelar?",
    "ResumoPagamento":"Resumo do Pagamento",
    "ConfirmaCancelarInfracao":"Confirma o cancelamento desta infração?",
    "Beneficiario":"Beneficiário",
    "IdentificadorInfracao":"Identificador Infração",
    "FecarInfracao":"Fechar Infração",
    "ParticipanteCredito":"Participante Crédito",
    "ParticipanteDebito":"Participante Débito",
    "Reportador":"Reportador",
    "DetalheInfracao":"Detalhe Infração",
    "DetalheAnalise":"Detalhe Análise",
    "ResultadoAnalise":"Resultado Análise",
    "Acatado":"Acatado",
    "Rejeitado":"Rejeitado",
    "SelecionarPixInfracao":"Selecionar Pix para Reportar Infração",
    "IncluirInfracao":"Incluir Infração",
    "NomeBeneficiario":"Nome do Beneficiário",
    "DocumentoBeneficiario":"Documento do Beneficiário",
    "DataEfetivacaoPagamento":"Data da efetivação do Pagamento",
    "DataIniciacaoPagamento":"Data da iniciação do Pagamento",
    "ResumoTransacao":"Resumo da Transação",
    "NomeRecebedor":"Nome do Recebedor",
    "ChavePixRecebedor":"Chave Pix do Recebedor",
    "QRCodePagamento":"Código do Pagamento",
    "DataLimite":"Data Limite",
    "NumeroContaDebito":"Conta Debitada",
    "FormaPagamento":"Forma de Pagamento",
    "ConfirmarPagamento":"Confirmar Pagamento",
    "PagamentoAte":"Pagamento Até",
    "PagamentoDe":"Pagamento De",
    "CodigoConsentimentoNaoRecebido":"Não foi recebido o código do consentimento.",
    "ConfirmarVoltarInstituicao":"Houve um erro na abertura do consentimento do Pagamento. Deseja retornar ao site da instituição iniciadora?",
    "ConfirmarConsentimentoPagamento":"Para confirmar o pagamento informe o seu Token. Após a confirmação você será redirecionado e o pagamento confirmado.",
    "ConfirmarCancelamentoPagamento":"Confirma o cancelamento do pagamento? Após o cancelamento você será redirecionado para a intituição iniciadora.",
    "RedirecionamentoOpenBanking":"Você está sendo redirecionado para a instituição iniciadora de pagamento",
    "RedirecionamentoAmbiente": "Estamos lhe redirecionando para o ambiente da iniciadora de pagamento",
    "Cambio": "Câmbio",
    "CambioConsultaOperacoes": "Consulta Operações de Câmbio",
    "CambioSemDados": "Sem registros",
    "CambioOperacoes": "Operações",
    "CambioStatus": "Status",
    "CambioTipoOperacao": "Tipo de Operação",
    "CambioDataOperacaoDe": "Data Operação de",
    "CambioDataOperacaoAte": "Data Operação até",
    "CambioComprovante": "Comprovante",
    "CambioContrato": "Contrato",
    "CambioCnpjCpf": "CPF/CNPJ",
    "CambioNome": "Nome",
    "CambioData": "Data",
    "CambioTipo": "Tipo",
    "CambioNrBoleto": "Nº Boleto",
    "CambioStatusPg": "Status Pagante",
    "CambioSegmento": "Segmento",
    "CambioNatureza": "Natureza",
    "CambioTaxa": "Taxa",
    "CambioIof": "IOF",
    "CambioIrRecolhido": "Ir. Recolhido",
    "CambioConta": "Conta",
    "CambioBanco": "Banco",
    "CambioAgencia": "Agência",
    "CambioAgenciaOperacao": "Operação",
    "CambioMoedaNacional": "Moeda Nacional",
    "CambioValor": "Valor",
    "CambioMoedaEstrangeira": "Moeda Estrangeira",
    "CambioMoeda": "Moeda",
    "DataLimitePagamento":"Data Limite Pagamento",
    "ValorTitulo":"Valor do Título",
    "ValorMinimoPagamento":"Valor Mínimo do Pagamento",
    "AdicionarLimiteOperacao":"Adicionar Limite por Operação",
    "LimitesOperacao":"Limites por Tipo de Operação",
    "ValorLimite":"Valor Limite",
    "NaoExistemLimites":"Não existem limites específicos por Tipo de operação",
    "ConfirmarExclusaoLimiteOperacao":"Confirma a exclusão do limite para operação {0}?",
    "Totalizadores":"Totalizadores",
    "MonitorAprovacaoOperacao":"Aprovação de Operações",
	"MonitorAprovacaoEdicaoUsuario":"Aprovação Edição de Usuário",
    "Aprovador": "Aprovador",
    "DataSolicitacao": "Data Solicitação",
    "DataFinalizacao": "Data Finalização",
	"MensagemAlteracaoPendenteAprovacao": "Ao alterar o telefone, email ou idioma, será gerado um pedido de aprovação para a área responsável. Deseja continuar?",
    "ComprovanteTransferencia":"Comprovante de Transferência",
    "ComprovantePagamento":"Comprovante de Pagamento",
    "ComprovantePix":"Comprovante",
    "ComprovanteTributo":"Comprovante de Tributos",
    "OuvidoriaSAC":"<strong>SAC</strong>: sac@wooribank.com.br - 08002912214 | <strong>OUVIDORIA</strong>: ouvidoria@wooribank.com.br - 08002912215.",
    "HorarioAtendimento":"Horário de atendimento: 10h - 16h.",
    "CodigoAutenticacao":"Código de Autenticação",
    "ErroMultiplosAcessos":"Limite de acessos consecutivos atingido. Por favor tente novamente em alguns segundos.",
    "BloqueioSenhaMsg":"Caro usuário, por favor entre em contato com o atendimento do Woori Bank para desbloquear seu acesso."
};

export const CALENDAR_PT = {
  firstDayOfWeek: 0,
  dayNames: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"],
  dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
  monthNames: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],
  monthNamesShort: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"]
}
